import "./HeroUnit.scss";

import React, { CSSProperties } from "react";

import { useTheme } from "../state/ThemeProvider";

type HeroUnitProps = {
  style?: React.CSSProperties;
};

export const HeroUnit: React.FC<HeroUnitProps> = ({ children, style }) => {
  const { themeName } = useTheme();
  return (
    <div style={style} className={`hero-unit hero-unit--theme-${themeName}`}>
      {children}
    </div>
  );
};

export const agileHeroUnitStyles: CSSProperties = {
  margin: "0px",
  padding: 20,
  minHeight: 200,
  display: "flex",
  justifyContent: "start",
  flexDirection: "column",
};

export const coreHeroUnitStyles: CSSProperties = {
  ...agileHeroUnitStyles,
  minHeight: 268,
};
